let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8KVl7")).then(() => parcelRequire('6Yq66'));